import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getUser, setSession, clearSession } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("efgh_token");
    if (token && !user) {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => clearSession());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      setSession(r.data.access_token, r.data.user);
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post("/auth/register", payload);
      setSession(r.data.access_token, r.data.user);
      setUser(r.data.user);
      return r.data.user;
    } finally { setLoading(false); }
  };

  const signupLab = async (payload) => {
    setLoading(true);
    try {
      const r = await api.post("/labs/signup", payload);
      setSession(r.data.access_token, r.data.user);
      setUser(r.data.user);
      return r.data;
    } finally { setLoading(false); }
  };

  const logout = () => { clearSession(); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, signupLab, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
